<script>
const MutationType = {
    SET_MEET: 'SET_MEET',
    SET_TOPICS: 'SET_TOPICS',
    SET_TOPIC: 'SET_TOPIC',
    SET_USERS: 'SET_USERS',
    SET_ACTION:'SET_ACTION',
    SET_CURRENT_TOPIC_ID: 'SET_CURRENT_TOPIC_ID',
    SET_STARTED_TIME: 'SET_STARTED_TIME',
    SET_MEET_DURATION: 'SET_MEET_DURATION',
    SET_MEET_INTERVAL: 'SET_MEET_INTERVAL',
    CLEAR_MEET_INTERVAL: 'CLEAR_MEET_INTERVAL',
    SET_CLOCK_RUNNING: 'SET_CLOCK_RUNNING',
    SET_FINISHED_TIME: 'SET_FINISHED_TIME',
    INSERT_COMMENT: 'INSERT_COMMENT',
    INSERT_CURRENT_USER: 'INSERT_CURRENT_USER',
    REMOVE_CURRENT_USER: 'REMOVE_CURRENT_USER'
}


export default {
    namespaced: true,
    state:{
        action:{
            type: null,
            data: null
        },
        current_topic: {},
        meet: {},
        topics: [],
        users: [],
        currentUsers: [],
        currentTopicId: null,
        startedTime: null,
        meetDuration: null,
        meetInterval: null,
        clockRunning: null,
        finishedTime: null,
    },
    getters:{
        actionType: state => {
            return state.action.type;
        },
        actionData: state => {
            return state.action.data;
        },
        orderedTopics: state =>{
            return state.topics.sort((a,b) => {return a.position - b.position});
        },
        availableTopics: (state, getters) =>{
            return getters.orderedTopics.filter(topic=>topic.id != state.currentTopicId);
        },
        pendingTopics: (state, getters)=>{
            return getters.availableTopics.filter(topic=>topic.finished_at == null);
        },
        finishedTopics: (state, getters)=>{
            return getters.availableTopics.filter(topic=>topic.finished_at != null);
        },
        findTopic: (state) => (id)=>{
            return state.topics.find(topic=>topic.id === id);
        },
        findUser: (state)=>(id)=>{
            return state.users.find(user=>user.id===id);
        },
        currentTopic:(state, getters)=>{
            return getters.findTopic(state.currentTopicId);
        },
        meetFinished: (state)=>{
            return state.meet.finished_at !== null;
        },
        userIsOnline: (state)=>id=>{
            return state.currentUsers.find(user=>user.id === id) != null;
        },
        nonParticipantUsers: (state)=>{
            var participantsIds = state.users.map(user=>user.id);
            return state.currentUsers.filter(user=>!participantsIds.includes(user.id));
        }
    },
    mutations:{
        [MutationType.SET_MEET](state, data){
            state.meet = {...state.meet, ...data};
        },
        [MutationType.SET_TOPICS](state, newTopics){
            state.topics = newTopics;
        },
        [MutationType.SET_TOPIC](state, {topicId=null, data=null}){
            var _topic = { ...state.topics.find(topic=>topic.id===topicId), ...data};
            state.topics = [
                ...state.topics.filter(topic=>topic.id!=_topic.id),
                _topic
            ];
        },
        [MutationType.SET_USERS](state, users){
            state.users = users;
        },
        [MutationType.SET_ACTION] (state, message){
            state.action = {...state.action, type: message.action, data: message};
        },
        [MutationType.SET_CURRENT_TOPIC_ID](state, topicId){
            state.currentTopicId = topicId;
        },
        [MutationType.SET_STARTED_TIME](state, startedTime){
            state.startedTime = startedTime;
        },
        [MutationType.SET_MEET_DURATION](state, meetDuration){
            state.meetDuration = meetDuration;
        },
        [MutationType.SET_MEET_INTERVAL](state, meetInterval){
            state.meetInterval = meetInterval;
        },
        [MutationType.CLEAR_MEET_INTERVAL](state){
            clearInterval(state.meetInterval);
        },
        [MutationType.SET_CLOCK_RUNNING](state, clockRunning){
            state.clockRunning = clockRunning;
        },
        [MutationType.SET_FINISHED_TIME](state, finishedTime){
            state.finishedTime = finishedTime;
        },
        [MutationType.INSERT_COMMENT](state, {topicId=null, comment=null}){
            state.topics.find(topic=>topic.id===topicId).comments.unshift(comment);
        },
        [MutationType.INSERT_CURRENT_USER](state, newUser){
            if(!state.currentUsers.find(user=>user.id ===newUser.id)){
                state.currentUsers.push(newUser);
            }
        },
        [MutationType.REMOVE_CURRENT_USER](state, oldUser){
            state.currentUsers = state.currentUsers.filter(user=>user.id!=oldUser.id);
        }
    },
    actions: {
        initStore({commit, state}, {meet=null, topics=null, users=null}){
            commit(MutationType.SET_MEET, meet);
            commit(MutationType.SET_TOPICS, topics);
            commit(MutationType.SET_USERS, users);
        },
        setAction({commit}, message){
            commit(MutationType.SET_ACTION, message);
        },
        setCurrentTopicId({commit}, topicId){
            commit(MutationType.SET_CURRENT_TOPIC_ID, topicId);
        },
        changeTopicDuration({commit}, {topicId=null, newDuration=null}){
            commit(MutationType.SET_TOPIC, {topicId: topicId, data: {
                duration: newDuration
            }});
        },
        changeTopicPosition({commit}, topicId, newPosition){
            commit(MutationType.SET_TOPIC, {topicId: topicId, data: {
                position: newPosition
            }});
        },
        startMeet({commit, state}, at=new Date()){
            commit(MutationType.SET_MEET, {start_at: at});
        },
        finishMeet({commit, state}, at=new Date()){
            commit(MutationType.SET_MEET, {finished_at: at});
        },
        finishTopic({commit}, topicId){
            commit(MutationType.SET_TOPIC, {topicId: topicId, data: {
                finished_at: new Date()
            }});
        },
        startTopic({commit}, topicId){
            commit(MutationType.SET_TOPIC, {topicId: topicId, data: {
                start_at: new Date()
            }});
        },
        startClock({commit}){
            commit(MutationType.SET_CLOCK_RUNNING, true);
        },
        pauseClock({commit, state}){
            commit(MutationType.SET_CLOCK_RUNNING, false);
        },
        insertComment({commit}, {topicId=null, comment=null}){
            commit(MutationType.INSERT_COMMENT, {topicId: topicId, comment: comment});
        },
        insertCurrentUser({commit}, user){
            commit(MutationType.INSERT_CURRENT_USER, user);
        },
        removeCurrentUser({commit}, user){
            commit(MutationType.REMOVE_CURRENT_USER, user);
        }
    }
}
</script>